import { CalendarClock, CalendarDays, ClipboardList, FileUp, Flag, Home, Shirt, TriangleAlert, Trophy } from 'lucide-react'
import { defineNav, useNavTitleFor, type NavItem } from '@region13/ui'

// The Coach app's destinations, in ONE flat list.
//
// The desktop sidebar, the phone drawer (opened by the bottom bar's More tab),
// the bottom bar's tabs, every page heading (useNavTitle) and the tab title all
// read COACH_NAV, so they cannot disagree. nav.drift.test.ts fails CI when a
// route, a label or a heading drifts from it.
//
// No capabilities and no groups: the coach app has a single `coach:read` tier.
export const COACH_NAV = defineNav<NavItem>({
  app: 'Coach',
  items: [
    { to: '/', label: 'Home', icon: Home },
    { to: '/games', label: 'Games', icon: CalendarDays },
    { to: '/cards', label: 'Game cards', icon: ClipboardList },
    { to: '/referees', label: 'Referees', icon: Flag },
    { to: '/standings', label: 'Standings', icon: Trophy },
    { to: '/jerseys', label: 'Jerseys', icon: Shirt },
    { to: '/practice', label: 'Practice', icon: CalendarClock },
    { to: '/forms', label: 'Forms', icon: FileUp },
    { to: '/incidents', label: 'Incidents', icon: TriangleAlert },
  ],
  groups: [],
  childRoutes: {},
})

/** The pages the phone bottom bar shows as tabs, in nav order; its last tab,
 *  More, opens the drawer with all nine. */
export const PHONE_TABS = ['/', '/games', '/cards', '/practice'] as const

/** The current page's heading: its nav label. */
export const useNavTitle = (): string => useNavTitleFor(COACH_NAV)
